import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useInfrastructureContext } from './InfrastructureContext';
import { trackClick } from './tracking';
import { setIsDropdownOpen } from '../../../../Map/actions/infrastructure/setIsDropdownOpen';
import {
  selectActiveType,
  selectIsDropdownOpen,
  selectIsInfrastructureOnMapEnabled,
  selectTypes,
} from '../../../../Map/selectors';
import { InfrastructureButton } from '../../../components/Navigation/Infrastructure';

export function InfrastructureControlContainer() {
  const isOpen = useSelector(selectIsDropdownOpen);

  const dispatch = useDispatch();
  const activeLayer = useSelector(selectActiveType);
  const layers = useSelector(selectTypes);
  const isInfrastructureOnMapEnabled = useSelector(selectIsInfrastructureOnMapEnabled);

  const { infrastructureButtonRef } = useInfrastructureContext();

  const handleClick = React.useCallback(() => {
    if (!isOpen) {
      trackClick();
    }
    dispatch(setIsDropdownOpen(!isOpen));
  }, [isOpen]);

  if (!isInfrastructureOnMapEnabled || layers.length === 0) {
    return null;
  }

  return (
    <InfrastructureButton
      ref={infrastructureButtonRef}
      title={activeLayer?.name}
      expanded={isOpen}
      onClick={handleClick}
    />
  );
}
